function Restock () {
    return(
        <div></div>
    );
}

export default  Restock;